export default {
    general: {
        password: "Passwort",
        or: "oder",
        task: "Aufgabe | Aufgaben",
        document: "Datei",
        register: "Register",
        folder: "Ordner",
        cancel: "Abbrechen",
        yes: "Ja",
        no: "Nein",
        search: "Suche",
        select: 'Auswählen',
        close: "Schließen",
        promptQuestion: 'Sind Sie sicher?',
        sessionExpired: 'Ihre Sitzung ist abgelaufen',
        loginFirst: 'Sie müssen eingeloggt sein, um auf den Einladungslink zugreifen zu können.',
        noPreview: 'Dateivorschau nicht verfügbar',
        reloadAppQuestion: 'Eine neue enaio coLab-Version ist verfügbar. Möchten Sie die App aktualisieren?',
        forbidden: 'Sie sind kein Projektmitglied',
        serverError: 'Server-Fehler Status {code}',
        notFound: 'Seite nicht gefunden',
        DMS_SERVICE_ERROR: 'Fehler im dms-service',
        errorPage: {
            title: 'Seite nicht gefunden',
            body: 'Die angeforderte Seite wurde nicht gefunden',
            backBtn: 'Zurück',
            homeBtn: 'Zur Startseite',
            objectNotFound: 'Die Vorschau für die Datei mit der ID {fileId} ist nicht verfügbar, da der geteilte Link nicht mehr gültig ist'
        },
        about: {
            menuTitle: 'Über coLab',
            componentVersion: 'Komponenten-Version',
            productVersion: 'Produktversion',
            manufacturer: 'Hersteller',
            manufacturerText: 'OPTIMAL SYSTEMS GmbH, Berlin, Deutschland',
            userDocumentation: 'Benutzerdokumentation'
        }
    },
    profile: {
        profile: "Benutzerprofil",
        logout: "Abmelden",
        language: "Sprache",
        title: "Benutzerprofil",
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: "E-Mail-Adresse",
        selectedLanguage: "Ausgewählte Sprache",
        saveChanges: "Änderungen speichern",
        messages: {
            action: {
                success: 'Benutzerprofil aktualisiert',
                error: 'Fehler beim Aktualisieren des Benutzerprofils'
            },
            validation: {
                email: 'Geben Sie eine gültige E-Mail-Adresse ein'
            }
        }
    },
    login: {
        username: "enaio Benutzername",
        password: "enaio Passwort",
        title: "Willkommen bei enaio coLab",
        email: "E-Mail-Adresse",
        login: "Anmelden",
        externalUsersTitle: 'Externe Benutzer',
        enaioUsersTitle: 'enaio-Benutzer',
        loginPending: "Melde Benutzer an ...",
        validation: {
            username: 'Benutzername darf nicht leer sein',
            password: 'Passwort darf nicht leer sein',
            wrongLogin: 'Falscher Benutzername oder falsches Passwort'
        },
        socialLogins: {
            google: 'Mit Google anmelden',
            linkedin: 'Mit LinkedIn anmelden',
            microsoft: 'Mit Microsoft anmelden',
            keycloak: 'Mit {companyName} anmelden'
        }
    },
    menu: {
        home: 'Startseite',
        overview: "Übersicht",
        files: "Dateien",
        tasks: "Aufgaben",
        settings: "Einstellungen",
        adminSettings: 'Administrator Einstellungen',
        hover: {
            logo: 'Übersicht der Projekträume',
            home: 'Projekt-Startseite',
            files: 'Projektdateien',
            tasks: 'Projektaufgaben',
            settings: 'Projekteinstellungen',
            adminSettings: 'Administrator Einstellungen',
        }
    },
    message: {
        profile: {
            savedSuccessfully: "Einstellungen wurden erfolgreich gespeichert"
        },
        wizard: {
            findError: {
                title: "Es ist ein Fehler aufgetreten.",
                text: "Sollte dieser Fehler wiederholt auftreten, kontaktieren Sie bitte Ihren Administrator.",
                message: "Fehlermeldung:"
            }
        }
    },
    tasks: {
        filter: {
            showAll: "Alle anzeigen",
            showNotCompleted: "Erledigte ausblenden"
        },
        completed: 'Abgeschlossen',
        title: 'Aufgabengruppe | Aufgabengruppen',
        noList: "Keine Liste vorhanden",
        noListSelected: "Keine Liste ausgewählt",
        addTask: "Aufgabe hinzufügen",
        editTask: 'Aufgabe bearbeiten',
        saveChanges: 'Änderungen speichern',
        task: "Aufgabe",
        taskgroup: "Aufgabengruppe",
        modified: "Bearbeitet am",
        addTaskGroup: "Gruppe anlegen",
        due: "Fällig am",
        dueNotSet: "Keine Fälligkeit gesetzt",
        assignUser: "Einem Benutzer zuweisen",
        assignedTo: 'Zugewiesen an',
        assignProjectMember: 'Projektmitglied zuweisen',
        projectMembers: 'Projektmitglieder',
        startTyping: 'Beginnen Sie mit der Eingabe...',
        removeAssignee: 'Zuweisung entfernen',
        filetasktitle: 'Aufgabe zur Datei "{0}" erstellen',
        selectTaskGroup: 'Aufgabengruppe auswählen',
        taskGroupName: 'Name der Aufgabengruppe',
        newTaskGroup: 'Neue Aufgabengruppe erstellen',
        editTaskGroup: 'Aufgabengruppe bearbeiten',
        noTasks: 'Keine anzeigbaren Aufgaben vorhanden',
        newTask: 'Neue Aufgabe erstellen',
        subject: 'Betreff',
        description: 'Beschreibung',
        dueDate: 'Fälligkeitsdatum',
        previewAttachments: 'Anlagenvorschau',
        messages: {
            action: {
                success: 'Aufgabe erstellt',
                error: 'Fehler beim Erstellen der Aufgabe',
                errorDeleteTaskGroup: 'Fehler beim Löschen der Aufgabengruppe',
                errorProjectMemberUpdate: 'Fehler beim Aktualisieren des Projektmitglieds',
                errorProjectMemberRemove: 'Fehler beim Entfernen des Projektmitglieds',
                errorTaskComplete: 'Fehler beim Ändern des Abschlussstatus der Aufgabe',
                errorCreateTaskGroup: 'Fehler beim Erstellen der Aufgabengruppe'
            },
            validation: {
                taskGroup: 'Aufgabengruppe auswählen',
                taskName: 'Aufgabenname eingeben',
                taskGroupName: 'Gruppenname darf nicht leer sein',
                taskSubject: 'Aufgabenbetreff darf nicht leer sein',
                taskDueDate: 'Das Fälligkeitsdatum der Aufgabe darf nicht in der Vergangenheit liegen',
                noMember: 'Kein Mitglied ausgewählt'
            }
        }
    },
    project: {
        title: "Projekt",
        projectmembers: "Projektmitglieder",
        projectmessages: 'Projektraum-Nachrichten',
        projectdetails: 'Projektraum-Details',
        opentask: 'Zugewiesene Aufgabe | Zugewiesene Aufgaben',
        noOpenTasks: 'keine offenen Aufgaben',
        collaborators: 'Mitarbeiter',
        dashboard: {
            openTasks: 'Aufgabe öffnen',
            myOpenTasks: 'Meine offenen Aufgaben',
            nextTask: 'Meine nächste Aufgabe',
            newMessages: 'Neue Nachrichten',
            zeroProjectMessage: 'Sie sind kein Mitglied eines Projekts',
            scrollFinished: 'Keine weiteren Projekträume',
            scrollNoResult: 'Keine Suchergebnisse',
            projectRoomName: 'Projektraumname',
            myProjectRooms: 'Meine Projekträume',
            deleteBtnTitle: 'PROJEKT LÖSCHEN',
            searchPlaceholder: 'Suche in Titel und Besitzer',
            labelTotalProjects: 'Projekte gesamt:',
            labelDisplayedProjects: 'Angezeigte Projekte:',
            labelSearchHitResults: 'Trefferanzahl:',
            labelOwnerBadge: 'BESITZER',
            labelOwners: 'Besitzer:',
            showMembersBtnTitle: 'MITGLIEDER ANZEIGEN',
            membersListModalTitle: 'Projektmitglieder',
            descriptionSuffix: 'MEHR ANZEIGEN',
            successMemberDelete: 'Mitglied {memberName} erfolgreich entfernt',
            errorMemberDelete: 'Mitglied \'{memberName}\' konnte nicht entfernt werden.',
            noProjectMembership: 'Sie sind nicht Mitglied in diesem Projekt.'
        },
        action: {
            errorLoading: 'Fehler beim Laden des Projekts {projectId}',
            successUpdate: 'Projekt aktualisiert',
            errorUpdate: 'Fehler beim Aktualisieren des Projekts {projectName}',
            successDelete: 'Projekt {projectName} erfolgreich gelöscht',
            errorDelete: 'Projekt \'{projectName}\' konnte nicht gelöscht werden',
            errorLoadingCollaborators: 'Fehler beim Laden von Mitarbeitern für {projectId}'
        },
        settings: {
            general: {
                noGeneralDeletedRoom: 'Dieser Projektraum wurde in enaio client gelöscht oder der Benutzer verfügt nicht über die entsprechenden Rechte, um diesen Projektraum einzusehen. Wenn Sie den Projektraum aus coLab entfernen möchten, gehen Sie zu “Erweitert > Projektraum löschen“ oder wenden Sie sich an Ihren enaio-Administrator.',
                title: "Allgemein",
                name: 'Projektname',
                description: "Beschreibung",
                namePlaceholder: "Projektname",
                descriptionPlaceholder: "Projektbeschreibung",
                tabGeneral: "Allgemein",
                tabParticipants: "Mitglieder",
                tabGroups: "Gruppen",
                tabAdvanced: "Erweitert",
                tabEmails: 'E-Mails',
                queryDepth: "Objektbaumtiefe",
                rootObject: "enaio-Wurzelobjekt",
                downloadRootObject: 'Download-Link zum enaio-Wurzelobjekt',
                uploadObjectType: "Upload-Dokumenttyp",
                showOrHide: 'Anzeigen/Verbergen',
                showMessages: 'Nachrichten anzeigen',
                showTasks: 'Aufgaben anzeigen',
                folderOrRegisterNotAvailable: 'Ordner oder Register nicht verfügbar',
                noUploadObjectTypeSelection: "Kein Dokumenttyp ausgewählt",
                qualified: "geeignet",
                colabTypeAvailable: 'coLab-Uploadtyp ist verfügbar',
                noColabTypeAvailable: 'Kein coLab-Uploadtyp verfügbar',
                contactAdmin: 'Bitte wenden Sie sich an Ihren enaio-Administrator',
                waitingUploadStatus: 'Warten auf coLab-Uploadstatus...',
                validation: {
                    projectName: 'Projektname darf nicht leer sein.'
                }
            },
            participants: {
                title: "Projektteilnehmer",
                invite: "Teilnehmer einladen",
                itsYou: "Das sind Sie",
                inviteDlg: {
                    title: 'Teilnehmer einladen',
                    bcc: 'E-Mail-Einladung als Bcc versenden',
                    email: 'E-Mail-Addressen der Teilnehmer',
                    emailPlaceholder: 'E-Mail-Adresse(n) eingeben',
                    message: "Nachricht",
                    valid: "Gültigkeit der Einladung in Tagen",
                    validPlaceholder: "Gültigkeit in Tagen",
                    send: 'Einladungen versenden',
                    validation: {
                        email: 'Geben Sie eine oder mehrere gültige E-Mail-Adressen ein',
                        period: 'Gültigkeitszeitraum eingeben - maximal 90 Tage',
                        role: 'Mitgliedsrolle darf nicht leer sein',
                        bcc: 'Bcc darf nicht leer sein'
                    },
                    action: {
                        info: 'Einladungen werden versendet',
                        error: 'Beim Versenden der Einladungen ist ein Fehler aufgetreten',
                        errorInvalidInvitation: 'Einladungen wurden nicht versendet, da eine oder mehrere E-Mail-Adressen ungültig sind. Bitte überprüfen Sie die E-Mail-Adressen und versuchen Sie sie erneut zu senden.'
                    }
                },
                action: {
                    lastOwner: 'Der letzte verbliebene Projektbesitzer darf nicht gelöscht werden',
                    errorChangeRole: 'Fehler beim Ändern der Mitgliedsrolle',
                    errorRemoveMember: 'Fehler beim Entfernen des Projektmitglieds',
                    successUpdateMember: 'Projektmitglied aktualisiert',
                    errorUpdateMember: 'Fehler beim Aktualisieren des Projektmitglieds'
                },
                removeMember: 'Mitglied löschen',
                changeRole: 'Mitgliedsrolle ändern',
                rolesLabel: 'Rollen',
                leaveProject: 'Projekt verlassen',
                roles: {
                    guest: "Gast",
                    member: "Standard",
                    owner: "Besitzer"
                }
            },
            invitations: {
                title: 'Einladungen',
                status: {
                    active: 'Aktiv',
                    expired: 'Abgelaufen'
                },
                text: {
                    created: 'Erstellt am',
                    expires: 'Läuft ab am',
                    noInvitations: 'Keine Einladungen zum Anzeigen vorhanden',
                    revokeInvitation: 'Einladung widerrufen'
                },
                errorRevoking: 'Die Einladung kann nicht widerrufen werden.'
            },
            advanced: {
                title: "Fortgeschritten",
                delete: "Projektraum löschen",
                deleteMessage: "Möchten Sie den Projektraum wirklich löschen?",
                validation: {
                    queryDepth: 'Tiefe der Belegabfrage muss eine Zahl zwischen 1 und 10 sein.'
                },
                exportProjectRoomContents: 'Export von Projektraum-Inhalten',
                downloadPDF: 'Projektraum-Inhalte als PDF herunterladen',
                includeMessages: 'Inklusive Nachrichten',
                includeTasks: 'Inklusive Aufgaben',
                includeMembers: 'Inklusive Projektmitglieder',
            },
            emails: {
                assignedTasks: 'E-Mail-Benachrichtigungen zu zugewiesenen Aufgaben erhalten',
                userEmailAddress: 'E-Mail-Benachrichtigungen werden gesendet an',
                noUserEmailAddress: 'Ihr Benutzerkonto ist nicht mit einer E-Mail-Adresse verbunden.',
                action: {
                    errorUpdating: 'Fehler beim Aktualisieren der E-Mail-Einstellungen',
                    successUpdating: 'E-Mail-Einstellungen wurden aktualisiert'
                }
            },
            apply: "Übernehmen",
            files: {
                zeroSizeFile: 'Leere Dateien können nicht hochgeladen werden',
                noFiles: 'Keine Dateien verfügbar',
                noFilesDeletedRoom: 'Dieser Projektraum wurde in enaio client gelöscht oder der Benutzer verfügt nicht über die entsprechenden Rechte, um diesen Projektraum einzusehen. Wenn Sie den Projektraum aus coLab entfernen möchten, gehen Sie zu “Einstellungen > Erweitert > Projektraum löschen“ oder wenden Sie sich an Ihren enaio-Administrator.',
                loadingMessage: 'Dateien werden geladen. Bitte warten ...',
                filteredRowCount: 'ausgewählt',
                totalRowCount: 'gesamt',
                errorLoadingFiles: 'Fehler beim Laden von Dateien',
                previewAfterResizing: 'Vorschau nach Größenänderung verfügbar',
                filterPlaceholder: 'Filtern...',
                downloadInProgress: 'Wird herunterladen...',
                downloadSuccess: 'Datei erfolgreich heruntergeladen',
                uploadInProgress: 'Wird hochgeladen...',
                downloadButton: 'Dateien herunterladen',
                downloadButtonTitle: 'Ausgewählte Dateien als .zip herunterladen',
                newDocumentButton: 'Neue Datei',
                newDocumentButtonTitle: 'Neue Datei hochladen',
                errorDownloadingFiles: 'Fehler beim Herunterladen der Dateien',
                noNameFolderTitle: '[UNBENANNTER_ORDNER]',
                uploadDialog: {
                    title: "Datei hochladen",
                    fieldTitle: "Titel",
                    fieldInfo: "Info",
                    fieldFile: 'Datei',
                    send: "Hochladen",
                    dropzoneText: "Hier Datei hinziehen oder klicken",
                    cancelUploadText: 'Datei löschen',
                    removeFileText: 'Datei löschen',
                    messages: {
                        success: 'Hochladen erfolgreich',
                        errorWhileUploading: 'Fehler beim Hochladen der Datei',
                        colabTypeNotAllowed: 'Es ist nicht erlaubt, Dateien in diesem Ordner hochzuladen',
                        maxUploadSizeExceeded: 'Maximale Dateigröße für den Upload von überschritten: ',
                        errorConfig: 'Der Beleg kann aufgrund inkompatibler enaio-Typeinstellungen nicht hochgeladen werden. Bitte wenden Sie sich an Ihren Projektraum-Administrator',
                        validation: {
                            title: 'Dateititel eingeben',
                            file: 'Datei ist nicht ausgewählt',
                            maxFilesReached: "Sie können nicht mehr als eine Datei hochladen"
                        }
                    }
                },
                editDialog: {
                    title: 'Datei bearbeiten',
                    send: 'Änderungen speichern',
                    fieldFile: 'Vorhandene Datei',
                    fileNotEditable: 'Diese Datei kann nicht bearbeitet werden. Sie können lediglich die Felder Titel und Info ändern.',
                    firstRevisionWarning: 'Durch Ihren Upload wird die vorhandene Dateiversion überschrieben. Wenn Sie die Versionen vergleichen und zusammenführen möchten, laden Sie zuerst die aktuellste Version herunter.',
                    secondRevisionWarning: 'Zu dieser Datei gibt es eine neue Version. Durch den Upload einer neuen Datei werden alle vorhandenen Änderungen überschrieben. Wenn Sie die Versionen vergleichen und zusammenführen möchten, laden Sie zuerst die aktuellste Version herunter.',
                    messages: {
                        success: 'Bearbeitung erfolgreich',
                        errorWhileEditing: 'Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es später noch einmal oder wenden Sie sich an Ihren Projektraum-Administrator.',
                        validation: {
                            title: 'Dateititel eingeben',
                            file: 'Datei ist nicht ausgewählt',
                            maxFilesReached: 'Sie können nicht mehr als eine Datei hochladen'
                        }
                    }
                },
                renameDialog: {
                    title: 'Datei umbenennen',
                    send: 'Änderungen speichern',
                    messages: {
                        success: 'Datei erfolgreich umbenannt',
                        error: 'Fehler beim Umbenennen der Datei'
                    }
                },
                replaceDialog: {
                    title: 'Datei ersetzen',
                    send: 'Änderungen speichern',
                    messages: {
                        success: 'Datei erfolgreich ersetzt',
                        error: 'Fehler beim Ersetzen der Datei.'
                    }
                }
            }
        },
        invitation: {
            title: 'Einladung zu einem enaio-coLab',
            description: 'Sie wurden zu einem Projekt eingeladen',
            question: 'Möchten Sie die Einladung annehmen?',
            action: {
                errorLoading: 'Fehler beim Laden der Einladungsinformationen',
                errorRedeeming: 'Fehler beim Einlösen der Einladung',
                errorRedeemingExpired: 'Fehler beim Einlösen der Einladung – Einladung abgelaufen',
                errorRedeemingInvalid: 'Fehler beim Einlösen der Einladung – Einladung ungültig',
                errorInvalidInvite: 'Einladung ungültig',
                errorExpiredInvite: 'Einladung abgelaufen',
                INVALID_EMAIL_FORMAT:'Ungültiges E-Mail-Format'
            }
        }
    },
    feed: {
        title: "Projekt Feeds",
        shareLinkCreated: 'Link zur Datei erstellt',
        shareLinkValid: 'Die Datei kann bis zum {date} geteilt werden',
        shareLinkNotActive: 'Link zu dieser Datei ist nicht aktiv',
        newProjectMember: 'Neues Projektmitglied',
        newProjectMemberMessage: 'Willkommen {userName} im Projektraum {projectName}',
        newMessage: {
            name: "Neue Nachricht",
            title: "Titel",
            message: "Nachricht",
            create: "Erstellen",
            discard: 'Verwerfen'
        },
        editMessage: {
            name: 'Nachricht bearbeiten',
            title: 'Titel',
            message: 'Nachricht',
            create: 'Speichern',
            discard: 'Verwerfen'
        },
        updated: 'Aktualisiert am',
        activatefeeds: "Feeds aktivieren",
        messages: {
            action: {
                success: 'Nachricht versendet',
                error: 'Fehler beim Versand der Nachricht',
                successDelete: 'Nachricht löschen',
                errorDelete: 'Fehler beim Löschen der Nachricht',
                successUpdate: 'Nachricht aktualisiert',
                errorUpdate: 'Fehler beim Aktualisieren der Nachricht'
            },
            validation: {
                messageTitle: 'Nachrichtentitel eingeben',
                messageContent: 'Nachrichteninhalt eingeben'
            }
        },
        action: {
            errorLoadFeed: 'Fehler beim Laden des Feeds für {projectId}',
            errorAddFeed: 'Fehler beim Hinzufügen des Feed-Elements für {projectId}',
            errorUpdateFeed: 'Fehler beim Aktualisieren des Feed-Elements für {projectId}'
        },
        actionButtons: {
            deleteMessage: 'Nachricht löschen',
            editMessage: 'Nachricht bearbeiten',
            goToFile: 'Gehe zu Datei'
        }
    },
    files: {
        title: "Titel",
        info: "Info",
        modified: "Geändert",
        actions: 'Aktionen',
        context: {
            download: "Herunterladen Datei",
            replace: 'Datei ersetzen',
            createtask: "Aufgabe erstellen",
            createmessage: "Nachricht erstellen",
            share: "Datei teilen",
            deleteDocument: 'Datei löschen',
            editDocument: 'Datei umbenennen',
            onlyOffice: 'OnlyOffice',
            deleteTask: 'Aufgabe löschen',
            editTask: 'Aufgabe aktualisieren',
            goToFile: 'Go to file DE',
            createTaskGroup: 'Aufgabenliste erstellen',
            deleteTaskGroup: 'Ausgabenliste löschen',
            editTaskGroup: 'Aufgabenliste aktualisieren',
            createTask: 'Aufgabe erstellen'
        },
        baseparams: {
            created: "Angelegt",
            updated: "Geändert",
            size: "Größe",
            filetype: "Typ"
        },
        action: {
            errorLoading: 'Fehler beim Laden der Dateien',
            successDelete: 'Datei gelöscht',
            errorDelete: 'Fehler beim Löschen der Datei'
        },
        queryDepthWarning: 'Ordner ist aufgrund der in den Einstellungen definierten Ordnertiefe nicht verfügbar. Bitte kontaktieren Sie den Projektbesitzer für mehr Informationen.'
    },
    wizard: {
        title: "Neuen Projektraum erstellen",
        fields: {
            name: "Name",
            description: "Beschreibung",
            descriptionTemplate: "",
            root: "Wurzelobjekt",
            queryDepth: 'Tiefe der Belegabfrage'
        },
        placeholder: {
            name: "Name des Projektraums",
            description: "Beschreibung des Projektraums"
        },
        create: "Erstellen",
        cancel: 'Abbrechen',
        owners: 'Besitzer',
        projectName: 'Projektname',
        duplicateProjectsLabel: 'Vorhandene Projekte aus demselben Ordner',
        validation: {
            roomName: 'Name für Projektraum eingeben',
            queryDepth: 'Tiefe der Belegabfrage muss eine Zahl zwischen 1 und 10 sein.'
        },
        error: {
            title: 'Es ist ein Fehler aufgetreten!',
            message: 'Wenn dieser Fehler wiederholt auftritt, wenden Sie sich bitte an Ihren Administrator.',
            onlyFromFolder: 'Ein Projektraum kann nur aus einem Ordner oder Register erstellt werden.',
            objectNotFound: 'Objekt mit der ID {id} wurde nicht gefunden. Grund könnten die unzureichenden Rechte des technischen Benutzers sein. Wenden Sie sich bitte an Ihren Administrator.',
            duplicateProjects: 'Fehler beim Laden vorhandener Projekte aus demselben Ordner.'
        }
    },
    share: {
        title: "Datei extern teilen",
        text: "Teilen-Link für die Datei erstellen",
        valid: "Gültigkeit des Links in Tagen",
        linkIsValid: 'Dieser Link zur Datei "{0}" ist bis zum {1} gültig.',
        create: "Link erstellen",
        deleteLink: "Teilen aufheben",
        close: "Schließen",
        notFound: 'Der Teilen-Link ist nicht vorhanden',
        messages: {
            action: {
                successRevoke: 'Dateifreigabe abgebrochen'
            }
        },
        validation: {
            period: 'Geben Sie die Gültigkeitsdauer an - maximal 365 Tage'
        }
    },
    preview: {
        download: "Herunterladen",
        actions: "Aktionen"
    },
    admin: {
        settings: {
            tabJobs: "Jobs",
            tabRolesManagement: "Rollenverwaltung",
            job1: "In coLab geteilte Objekte markieren",
            description1: "Wiederkehrender Job, der Objekte in coLab markiert",
            jobs: {
                run: "Job ausführen",
                errorMarkJob: 'Job fehlgeschlagen',
                successMarkJob: 'Job erfolgreich ausgeführt'
            },
            rolesManagement: {
                addRole: "Neue Rolle hinzufügen",
                clone: "Klonen",
                edit: "Bearbeiten",
                delete: "Löschen",
                modal: {
                    save: "Rolle speichern"
                },
                roleDialogue: "Rollen zuweisen",
                successDeleteRole: 'Rolle erfolgreich gelöscht',
                errorDeleteRole: 'Sie haben nicht die erforderlichen Rechte, um diese Aktion auszuführen.',
                successCreateRole: 'Rolle erfolgreich erstellt/bearbeitet',
                errorCreateRole: 'Sie haben nicht die erforderlichen Rechte, um diese Aktion auszuführen.',
                errorAddNewRole: 'Rollenname ist ein Pflichtfeld',
                NAME_TAKEN:'Dieser Name existiert bereits.',
                ROLE_IN_USE:'Rolle wird verwendet',
                roleName: 'Rollenname',
                rights: {
                    DOWNLOAD_FILE:"Datei herunterladen",
                    REPLACE_FILE: "Datei ersetzen",
                    CREATE_TASK: "Aufgabe erstellen",
                    DELETE_TASK: "Aufgabe löschen",
                    UPDATE_TASK: "Aufgabe aktualisieren",
                    CREATE_TASK_LIST: "Aufgabenliste erstellen",
                    DELETE_TASK_LIST: "Ausgabenliste löschen",
                    UPDATE_TASK_LIST: "Aufgabenliste aktualisieren",
                    CREATE_MESSAGE: "Nachricht erstellen",
                    DELETE_MESSAGE: "Nachricht löschen",
                    UPDATE_MESSAGE: "Nachricht aktualisieren",
                    SHARE_FILE: "Datei teilen",
                    CANCEL_SHARE_FILE: "Datei nicht mehr teilen",
                    DELETE_FILE: "Datei löschen",
                    RENAME_FILE: "Datei umbennenn",
                    ADD_NEW_FILE: "Neue Datei hinzufügen",
                    CHANGE_PROJECT_ROOM_NAME: "Projektraum umbenennen",
                    CHANGE_PROJECT_ROOM_DESCRIPTION: "Projektraumbeschreibung bearbeiten",
                    CHANGE_PROJECT_MEMBER_ROLE: "Rolle des Projektmitglieds ändern",
                    EXIT_PROJECT_ROOM: "Projekraum verlassen",
                    CREATE_INVITATION:"Einladung erstellen",
                    DELETE_INVITATION:"Einladung löschen",
                    CHANGE_EMAIL_NOTIFICATION:"E-Mail-Benachrichtigung bearbeiten",
                    CHANGE_FILE_TREE_DEPTH:"Objektbaumtiefe bearbeiten",
                    DELETE_PROJECT_ROOM:"Projektraum löschen",
                    CHANGE_SHOW_MESSAGE:"Nachrichtenansicht bearbeiten",
                    CHANGE_SHOW_TASKS:"Aufgabenansicht bearbeiten",
                    DELETE_MEMBERSHIP:"Mitgliedschaft löschen"

                },
            },
        }
    }
};
